import { phosphorLibrary as i } from "./phosphor.js";
import { simpleLibrary as t } from "./simple.js";
import { legacyIconMap as l } from "../data/legacy-icon-map.js";
import { legacyIconNames as o } from "../data/legacy-icon-list.js";
const g = ["solid", "line", "brand"], s = [
  // These icons aren't available in Phosphor
  "line/computer-device-mobile-phone-iphone-x-back",
  "solid/computer-device-mobile-phone-iphone-x-back",
  "line/interface-text-formatting-left-open-quote",
  "solid/interface-text-formatting-left-open-quote",
  // These logos aren't available in Simple Icons
  "brand/brand-adobe",
  "brand/brand-amazon",
  "brand/brand-gaming-nintendo-switch",
  "brand/brand-gaming-xbox-live",
  "brand/brand-platform-microsoft-windows",
  "brand/brand-social-media-linkedin",
  "brand/programming-language-csharp",
  "brand/programming-language-css3",
  "brand/programming-language-java",
  "brand/programming-language-objc",
  "brand/programming-language-powershell"
];
function m(n) {
  const [r, e] = n.split("/");
  return { name: e, group: r };
}
function h(n) {
  const [r, e] = n.split("/");
  return {
    name: e,
    group: r
  };
}
function p(n) {
  return g.includes(n);
}
function b(n) {
  const { name: r, group: e } = m(n);
  return p(e) ? o[e].some((c) => c === r) : !1;
}
function d(n) {
  const r = l[n];
  return r ? i.belongsToLibrary(r) ? i.resolveUrl(r) : t.belongsToLibrary(r) ? t.resolveUrl(r) : "" : "";
}
function a(n, r) {
  return `${r}/${n}`;
}
const x = {
  name: "legacy",
  icons: [
    ...o.solid.map((n) => a(n, "solid")),
    ...o.line.map((n) => a(n, "line")),
    ...o.brand.map((n) => a(n, "brand"))
  ].filter((n) => !s.includes(n)),
  belongsToLibrary: b,
  resolveUrl: d
};
export {
  s as excludedLegacyIcons,
  p as isLegacyIconGroup,
  g as legacyIconGroups,
  x as legacyLibrary,
  h as parseLegacyIconKey,
  m as parseStringAsLegacyIconKey
};
